<template>
  <div class="divBox">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="container">
          <el-form size="small" inline label-width="100px">
            <el-form-item label="关键字：" class="width100" style="display: inline-block;">
              <el-input
                v-model="tableFrom.keywords"
                @keyup.enter.native="getList(1)"
                placeholder="请输入分类名称/sku"
                class="selWidth"
                size="small"
              >
                <el-button slot="append" icon="el-icon-search" size="small" class="el-button-solt" @click="getList(1)" />
              </el-input>
            </el-form-item>
            <el-form-item label="库存状态：" class="width100" style="display: inline-block;">
              <el-select v-model="tableFrom.num" placeholder="请选择" @change="getList(1)">
                <el-option
                  v-for="item in numList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-button type="primary" @click="stashFn">立即出库</el-button>
          </el-form>
        </div>
        <cards-data :card-lists="cardLists" />
      </div>
      <el-table
        v-loading="listLoading"
        :data="tableData.data"
        style="width: 100%"
        height="600"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="recovery_stock_id"
          min-width="50" />
        <el-table-column
          label="sku"
          prop="sku"
          min-width="200" >
          <template slot-scope="scope">
            {{scope.row.category_name}} {{scope.row.sku}}
          </template>
        </el-table-column>
        <el-table-column
          label="在库数量"
          prop="recovery_num"
          min-width="100" />
        <el-table-column
          label="买入数量"
          prop="outbound_num"
          min-width="100">
          <template slot-scope="scope">
            {{Number(scope.row.plat_outbound_num)?scope.row.plat_outbound_num:'0'}}
          </template>
        </el-table-column>
        <el-table-column
          label="买入平均单价"
          prop="outbound_price"
          min-width="100" >
          <template slot-scope="scope">
            {{Number(scope.row.plat_outbound_price)?scope.row.plat_outbound_price:'0'}}
          </template>
        </el-table-column>
        <el-table-column
          label="买入总金额"
          prop="outbound_amount"
          min-width="100" >
          <template slot-scope="scope">
            {{Number(scope.row.plat_outbound_amount)?scope.row.plat_outbound_amount:'0'}}
          </template>
        </el-table-column>
        <el-table-column
          label="卖出数量"
          prop="outbound_num"
          min-width="100">
          <template slot-scope="scope">
            {{Number(scope.row.outbound_num)?scope.row.outbound_num:'0'}}
          </template>
        </el-table-column>
        <el-table-column
          label="卖出平均单价"
          prop="outbound_price"
          min-width="100" >
          <template slot-scope="scope">
            {{Number(scope.row.outbound_price)?scope.row.outbound_price:'0'}}
          </template>
        </el-table-column>
        <el-table-column
          label="卖出总金额"
          prop="outbound_amount"
          min-width="100" >
          <template slot-scope="scope">
            {{Number(scope.row.outbound_amount)?scope.row.outbound_amount:'0'}}
          </template>
        </el-table-column>

        <el-table-column
          label="批号"
          prop=""
          min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.stock_batch?scope.row.stock_batch.length:false">
              <p v-for="(item,index) in scope.row.stock_batch"  style="margin: 0">
                {{item.batch_number}} <span style="font-size: 16px;color: red;margin-left: 10px">x{{item.batch_num}}</span>
              </p>
            </div>
            <p v-else>--</p>
          </template>
        </el-table-column>
        <el-table-column
          label="异常数量"
          prop=""
          min-width="100">
          <template slot-scope="scope">
            <p style="margin: 0">
              {{Number(scope.row.total_worn_num)?scope.row.total_worn_num:'0'}}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="setAbnormalStock(scope.row)">设置异常</el-button>
            <el-button type="text" size="small"  @click="stockDetailsLstFn(scope.row)">查看异常明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          :page-sizes="[20, 40, 60, 80]"
          :page-size="tableFrom.limit"
          :current-page="tableFrom.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.total"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <el-dialog
      title="异常明细"
      :visible.sync="stockDetailShow"
      width="45%"
      top="50px"
      :before-close="stockDetailClose"
    >
      <el-table
        v-loading="listLoading"
        :data="stockDetail"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          label="ID"
          prop="stock_worn_id"
          min-width="50" />
        <el-table-column
          label="数量"
          prop="worn_num"
          min-width="50" />
        <el-table-column
          label="备注"
          prop="worn_reason"
          min-width="100" />
        <el-table-column
          label="异常图片"
          prop=""
          min-width="200">
          <template slot-scope="scope">
            <img :src="item" style="width: 40px;height: 40px;margin: 0 5px" @click="previewFn(item)" v-for="(item,index) in imgFn(scope.row.worn_image)"/>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          min-width="100" />

      </el-table>
    </el-dialog>

    <el-dialog
      title="修改库存"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-form :model="ruleForm" status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="修改库存" prop="pass">
          <el-radio v-model="ruleForm.type" :label="1">增加</el-radio>
          <el-radio v-model="ruleForm.type" :label="0">减少</el-radio>
        </el-form-item>
        <el-form-item label="库存" prop="checkPass">
          <el-input-number v-model="ruleForm.stock"  :min="1" :max="ruleForm.type == 0 ?stockItem.recovery_num:1000000" label="描述文字"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="checkPass">
          <el-input v-model="ruleForm.remark" placeholder="请输入内容" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="" prop="checkPass" v-if="ruleForm.type == 1">
          <el-button type="primary" @click="addBatchFn">增加批号</el-button>
        </el-form-item>

        <el-form-item label="录入批号" prop="checkPass" v-for="(item,index) in ruleForm.batch_list"  v-if="ruleForm.type == 1">
          <el-input v-model="item.batch_number" placeholder="请输入内容" style="width: 300px;"></el-input>
          <el-input-number v-model="item.batch_num" @change="batchChange($event,index)" :max="maxFn(item,index)" label="描述文字" style="margin-left: 20px"></el-input-number>
        </el-form-item>
        <el-form-item label="批号" prop="checkPass" v-for="(item,index) in stockItem.stock_batch"  v-if="ruleForm.type == 0">
          <el-input v-model="item.batch_number" :disabled="true" placeholder="请输入内容" style="width: 300px;"></el-input>
          <el-input-number v-model="item.batchNum" @change="batchChange($event,index)" :max="stockMaxFn(item,index)" label="描述文字" style="margin-left: 20px"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="batchConfirm" v-loading="btnLoading">确 定</el-button>
  </span>
    </el-dialog>


    <el-dialog
      title="出库订单"
      :visible.sync="stashShow"
      width="80%"
      top="10px"
      :before-close="stashClose">

      <div style="height: 900px;overflow-y: scroll">
        <el-form ref="form" label-width="80px"  @submit.native.prevent>
          <div style="display: flex;align-items: center">
            <el-form-item label="搜索商品">
              <el-input v-model="keywords" style="width: 200px"    @keyup.enter.native="getSearchFn"></el-input>
              <el-button type="primary" @click="getSearchFn">搜索</el-button>
            </el-form-item>
          </div>
        </el-form>
        <div style="display:flex;align-items: center;flex-wrap: wrap">
          <el-checkbox-group v-model="checkList" @change="checkChangeFn">
          <div style="display: flex;align-items: center;border: 1px solid #dcdfe6;padding:12px 20px;margin: 8px" v-for="(item,index) in itemList">
              <el-checkbox :disabled="item.recovery_num==0" :label="item">{{item.category_name}} {{item.sku}} </el-checkbox>
          </div>
          </el-checkbox-group>
        </div>

        <div style="display:flex;flex-direction: column;flex-wrap: wrap;margin-top: 20px">
          <div style="margin-top: 8px; border-bottom: 1px solid #f5f5f5;padding: 4px 0" v-for="(item,index) in checkLst" >
            <div style="display: flex;align-items: center">
              <span class="font16" style="width: 300px;">{{item.category_name}} {{item.sku}}</span>
              <span style="margin-left: 20px;width: 100px" class="font16" >在库数量：{{item.recovery_num}}</span>
              <span style="margin-left: 20px;width: 100px" class="font16" >异常总数量：</span><span style="font-size: 18px;color: red">{{item.total_worn_num?item.total_worn_num:'0'}}</span>
              <span style="margin-left: 20px" class="font16">出库数量：</span>
              <el-input-number style="margin-left: 10px" size="mini" v-model="item.recoveryNum" @change="inputNumChangeFn($event,index)" :max="item.recovery_num" label="描述文字"></el-input-number>
              <span style="margin-left: 20px" class="font16" v-if="item.total_worn_num">出库异常数量：</span>
              <el-input-number style="margin-left: 10px" size="mini" v-model="item.worn_two_num" :min="0" :max="wornMaxFn(item)" label="描述文字" v-if="item.total_worn_num"></el-input-number>
              <el-button type="primary" size="mini" @click="selectBatchFn(item,index)" v-if="item.stock_batch.length" style="margin-left: 20px">选择批号</el-button>
            </div>
            <div class="" v-for="(item1,index1) in item.stockWorn" style="display: flex;align-items: center;padding: 5px">
              <span style="width: 100px" class="font16" >异常数量：{{item1.worn_num?item1.worn_num:'0'}}</span>
              <span style="margin-left: 20px;width: 300px" class="font16" >异常备注：{{item1.worn_reason}}</span>
              <div style="margin-left: 20px;display: flex;align-items: center" class="font16" >异常图片：<img style="width: 30px;height: 30px;margin-right: 10px" @click="previewFn(v)" :src="v" v-for="(v,i) in imageFn(item1)"> </div>
            </div>
            <div style="display: flex;flex-direction: column" v-if="item.batch_list.length">
              <div v-for="(item1,index1) in item.batch_list" style="margin-top:10px">
                <span class="font16">选择批号：</span>
                <el-select v-model="item1.batch_number" size="mini" placeholder="请选择" @change="selectChangeFn($event,index,index1)" style="width: 200px" >
                  <el-option
                    v-for="(i,indx) in item.stock_batch"
                    :key="i.stock_batch_id"
                    :label="i.batch_number"
                    :value="i.batch_number"
                  >
                  </el-option>
                </el-select>
                <span style="margin-left: 20px" class="font16">批号数量：</span>
                <el-input-number style="margin-left: 10px" size="mini" v-model="item1.batch_num" @change="batchChangeFn($event,index,index1)"  :max="batchMaxFn(item1,index,index1)" label="描述文字"></el-input-number>
              </div>
            </div>
          </div>
        </div>

        <el-form ref="form" label-width="80px">
          <el-form-item label="备注">
            <el-input v-model="out_remark" style="width: 200px" ></el-input>
          </el-form-item>
          <el-form-item label="选择客户">
            <el-select v-model="custom_value" placeholder="请选择" style="width: 200px" >
              <el-option
                v-for="i in customList"
                :key="i.custom_id"
                :label="i.custom_name"
                :value="i.custom_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="stashShow = false">取 消</el-button>
        <el-button type="primary" @click="stockOutConfirm">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog
      title=""
      :visible.sync="previewShow"
      width="40%">
      <div style="display: flex;align-items: center;justify-content: center;width: 100%">
        <img :src="previewImg" style="width: 400px;height: 400px;" alt="">
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="previewShow = false">关 闭</el-button>
  </span>
    </el-dialog>


    <el-dialog
      title="异常处理"
      :visible.sync="abnormalVisible"
      width="50%">
      <el-form status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="修改库存" prop="pass">
          <el-radio v-model="abnormalForm.type" :label="1">增加</el-radio>
          <el-radio v-model="abnormalForm.type" :label="0" v-if="abnormalData.stockWorn.length">异常处理</el-radio>
        </el-form-item>
        <div style="display: flex;align-items: center" v-for="(item,index) in abnormalData.stockWorn" v-if="abnormalForm.type==0">
          <el-form-item label="异常数量" prop="checkPass">
            <el-input-number size="mini" v-model="item.num"  :min="0" :max="item.worn_num" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="备注" prop="checkPass">
            <el-input size="mini" v-model="item.worn_reason" placeholder="请输入内容" style="width: 200px"></el-input>
          </el-form-item>
        </div>
        <div v-if="abnormalForm.type == 1">
          <el-form-item label="异常数量" prop="checkPass">
            <el-input-number size="mini" v-model="abnormalForm.worn_num"  :min="0"  label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="备注" prop="checkPass">
            <el-input size="mini" v-model="abnormalForm.worn_reason" placeholder="请输入内容" style="width: 200px"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="abnormalVisible = false">取 消</el-button>
        <el-button type="primary" @click="abnormalConfirm" v-loading="btnLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // +----------------------------------------------------------------------
  // | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
  // +----------------------------------------------------------------------
  // | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
  // +----------------------------------------------------------------------
  // | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
  // +----------------------------------------------------------------------
  // | Author: CRMEB Team <admin@crmeb.com>
  // +----------------------------------------------------------------------
  import { roterPre } from '@/settings'
  import {fromList} from "@/libs/constants";
  import {
    recoveryStockCardListApi,stockSetWorn,
    recoveryStockListApi, outStockOrderCreate, stockSetUpdate , customLst , stockDetailsLst
  } from "@/api/recovery";
  import cardsData from "@/components/cards";
  import {cardListApi} from "@/api/order";
  import {changeNowMoneyApi} from "@/api/user";
  export default {
    name: 'appraisalEntityOrder',
    components: {cardsData},
    computed:{
      /**
       * 计算当前批号的最大值
       * */
      batchMaxFn(){
        return function (item,index,index1) {
          let indx = null
          console.log(item)
          if(item.batch_number){
            if(item.maxNum-this.checkLst[index].recoveryNum>0){
              return this.checkLst[index].recoveryNum
            }else{
              return item.maxNum
            }
          }else{
            return 100
          }
        }
      },
      wornMaxFn(){
        return function (item) {
            if(item.total_worn_num - item.recoveryNum > 0){
              return item.recoveryNum
            }else{
              return item.total_worn_num
            }
        }
      },
      imageFn(){
        return function (item) {
          console.log(item.worn_image)
            if(item.worn_image){
              return JSON.parse(item.worn_image)
            }else{
              return item.worn_image
            }
        }
      },
      /**
       * 减少库存批号的最大值
       * */
      stockMaxFn(){
        return function (item,index) {
          if(item.batch_num - this.ruleForm.stock >0){
            return this.ruleForm.stock
          }else{
            return item.batch_num
          }
        }
      },
      batchListFn(){
        return function (row) {
          if(row.batch_list){
            return JSON.parse(row.batch_list)
          }else{
            return []
          }
        }
      },
      // 处理图书是json对象
      imgFn(){
        return function (img) {
            return JSON.parse(img)
        }
      },
      maxFn(){
        return function (item,index) {
          let num = 0
          this.ruleForm.batch_list.map((item1,index1)=>{
            num+= item1.batch_num
          })
          return  this.ruleForm.stock - num + item.batch_num
        }
      }

    },
    data() {
      return {
        custom_value:'',
        checkList:[],
        out_remark:'',
        abnormalVisible:false,
        props: { checkStrictly: true, emitPath: false},
        moren: require("@/assets/images/f.png"),
        colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
        listLoading: true,
        btnLoading:false,
        tableData: {
          data: [],
          total: 0
        },
        numList:[
          {
            value:'全部',
            id:'0'
          },
          {
            value:'有库存',
            id:'1'
          }
        ],
        abnormalForm:{
          type:1,
          worn_num:1,
          stock:1,
        },
        form:{},
        detailFrom:{
          page:1,
          limit:15
        },
        previewShow:false,
        recovery_stock_id:0,
        checkLst:[],
        roterPre: roterPre,
        customList:[],
        stashShow:false,
        tableFrom: {
          page: 1,
          limit: 20,
          num:'1'
        },
        previewImg:'',
        orderChartType: {},
        abnormalData:{
          stockWorn: []
        },
        stockId:0,
        fromList: fromList,
        cardLists: [],
        submitShow:false,
        keywords:'',
        stockDetail:{},
        stockDetailShow:false,
        stockItem:{},
        timeVal: [],
        value:'',
        itemList:[],
        dialogVisible:false,
        loading: false,
        formData: {},
        ruleForm:{
          type:1,
          stock:1,
          batch_list:[],
        },
        appraisal_order_id:'',
        recoveryCateList:[],
      }
    },
    mounted() {
      this.getList(1)
      // this.getCardList()
      this.getcustomLstFn()
    },
    methods: {
      /**
       * @description 设置异常弹框
       * */
      setAbnormalStock(row){
        this.abnormalVisible = true
        this.stockId = row.recovery_stock_id
        row.stockWorn.map((v,i)=>{
            v.num = v.worn_num
        })

        this.abnormalData={
          stockWorn:JSON.parse(JSON.stringify(row)).stockWorn
        }
        this.abnormalForm = {
          type:1,
          worn_num: 1,
          worn_reason:''
        }
      },
      stockDetailClose(){
        this.stockDetailShow = false
      },
      selectChangeFn(e,index,index1){
        let maxNum = null

        this.checkLst[index].stock_batch.some((v,i)=>{
          if(v.batch_number == e){
            maxNum = v.batch_num
          }
        })
        // 切换批号 默认批号数量为1
        this.checkLst[index].batch_list[index1].batch_num = 1
        if(maxNum){
          this.checkLst[index].batch_list[index1].maxNum = maxNum
        }
        this.$forceUpdate()
      },
      stashClose(){
        this.stashShow = false
      },
      /**
       * 异常提交
       * */
      abnormalConfirm(){
       if(this.abnormalForm.type==0){
         this.abnormalData.stockWorn.map((v,i)=>{
           v.worn_num = v.worn_num - v.num
         })
       }
        let obj = [
          {
            worn_num:this.abnormalForm.worn_num,
            worn_reason:this.abnormalForm.worn_reason,
            worn_image:"[]",
          }
        ]
        this.abnormalData.stockWorn
        let params ={
          type:this.abnormalForm.type,
          stock:this.abnormalForm.worn_num,
          worn_list:this.abnormalForm.type==0?this.abnormalData.stockWorn:obj
        }
        stockSetWorn(this.stockId,params).then(res=>{
          this.$message.success(res.message)
          this.getList()
          this.abnormalVisible = false
        }).catch(err=>{
          this.$message.error(err.message)
        })

      },
      // 预览
      previewFn(v){
        this.previewShow=true
        this.previewImg = v
      },
      /**
       * 出库
       * */
      async stockOutConfirm(){
        if(this.submitShow){
          return
        }
        if(!this.checkLst.length){
          this.$message.error('请选择出库商品')
          return
        }
        if(!this.custom_value){
          this.$message.error('请选择客户')
          return
        }
        let indx = null
        this.checkLst.map((item,index)=>{
          item.batch_list.map((v,i)=>{
            if(!v.batch_number){
              indx = 'null'
            }
          })
        })
        if(indx){
          this.$message.error('请检查批号')
          return
        }
        let params = {
          custom_id: this.custom_value,
          out_remark: this.out_remark,
          out_product:this.checkLst
        }
        this.submitShow = true
        try{
          let data = await outStockOrderCreate(params)
          this.submitShow = false
          this.$message.success(data.message)
          this.stashShow = false
          this.getList()
        }catch(err){
          this.$message.error(err.message)
          this.submitShow = false
        }


      },
      /**
       * 监听批号数量 为0 删除该批号
       * */
      batchChangeFn(e,index,index1){
        if(e<=0)
        {
          this.checkLst[index].batch_list.splice(index1,1)
        }
        this.$forceUpdate()
      },
      /**
       * 查看异常明细
       * */
      stockDetailsLstFn(row){
        console.log(row)
        this.recovery_stock_id = row.recovery_stock_id
        this.stockDetailShow = true
        this.stockDetail = row.stockWorn
      },
      getDetailListFn(){
        stockDetailsLst(this.recovery_stock_id,this.detailFrom).then(res=>{
          this.stockDetail = res.data.list
          this.detailFrom.total = res.data.count

        })
      },
      /**
       * 获取客户列表
       * */
      getcustomLstFn(){
        customLst({all:1}).then(res=>{
            this.customList = res.data.list
        })
      },
      /**
       * 商品出库数量监听  用于减为0时删除该项
       * */
      inputNumChangeFn(e,index){
        this.$forceUpdate()
          if(e<=0)
          {
            let indx = null
            if(
              this.checkList.some((v,i)=>{
                if(v.recovery_attr_id == this.checkLst[index].recovery_attr_id)
                { indx = i
                  return true}})
            )
            {
              this.checkList.splice(indx,1)
            }

            if(this.checkList.indexOf(this.checkLst[index]) != -1){
              this.checkList.splice(this.checkList.indexOf(this.checkLst[index]),1)
            }
            this.$nextTick(()=>{
              this.checkLst.splice(index,1)
            })

          }
      },
      checkChangeFn(e){
        // 判断是选中
        console.log(e)
        if(e.length - this.checkLst.length > 0){
          e.map((v,i)=>{
            let indx = 'null'
            this.checkLst.some((item,index)=>{
              if(v.recovery_attr_id == item.recovery_attr_id){
                indx = index
                return true
              }
            })
            if(indx == 'null'){
              v.recoveryNum = 1
              v.batch_list = []
              this.checkLst.push(v)
            }
          })
        }else{ // 取消选中
          this.checkLst.map((v,i)=>{
            let indx = 'null'
            e.some((item,index)=>{
              if(v.recovery_attr_id == item.recovery_attr_id){
                indx = index
                return true
              }
            })
            if(indx == 'null'){
              this.checkLst.splice(i,1)
            }
          })
        }

        // this.checkLst = JSON.parse(JSON.stringify(e))

      },
      /**
       * 搜索
       * */
      getSearchFn(){
        if(!this.keywords){
          this.$message.error('请输入搜索内容')
          return
        }
        recoveryStockListApi({page:1,limit:'max',keywords:this.keywords,num:1}).then(res => {
          this.itemList = res.data.list
          // this.getCardList()
        }).catch(res => {
          this.$message.error(res.message)
        })
      },
      /**
       * 选择批号
       * */
      selectBatchFn(item,index){
        // 判断添加的批号数量是否 大于等于 出库数量
        if(this.checkLst[index].batch_list.length >= this.checkLst[index].recoveryNum){
          return
        }
        // 判断添加的批号是否 大于等于 在库数量
        if(item.recovery_num <= this.checkLst[index].batch_list.length){
          return
        }
        // 判断添加的批号是否 大于等于 在库商品批号数量
        if(this.checkLst[index].batch_list.length>=item.stock_batch.length){
          return
        }
        this.$nextTick(()=>{
          this.checkLst[index].batch_list.push({batch_number: '',batch_value:'',maxNum:1})
        })
        this.$forceUpdate()
      },
      /**
       * 增加批号
       * */
      addBatchFn(){
        let num = 0
        this.ruleForm.batch_list.map((item,index)=>{
          num+= item.batch_num
        })
        if(num < this.ruleForm.stock){
          this.ruleForm.batch_list.push({batch_number:'',batch_num: 1})
        }
      },
      /**
       * 出库弹框
       * */
      stashFn(){
        this.checkLst = []
        this.checkList = []
        this.keywords = ''
        this.itemList = []
        this.out_remark = ''
        this.custom_value = ''
        this.stashShow = true
      },
      /**
       * 修改库存
       */
      async batchConfirm(){
        /**
         * 判断批号是否输入完整
         * */
        if(this.btnLoading)return
        this.btnLoading = true
        if(this.ruleForm.batch_list.some((v,i)=>{if(!v.batch_number)return true}))
        {
          this.$message.error('请检查批号是否输入完整')
          this.btnLoading = false
          return
        }
        if(this.ruleForm.type == 0){
          this.stockItem.stock_batch.map((v,i)=>{
            if(v.batchNum){
              v.batch_num = v.batchNum
              this.ruleForm.batch_list.push(v)
            }
          })
        }
        if(!this.ruleForm.remark){
          this.$message.error('请输入备注')
          this.btnLoading = false
          return
        }
         stockSetUpdate(this.stockId,this.ruleForm).then((res)=>{
           this.getList()
           this.handleClose()
           this.btnLoading = false
         }).catch(err=>{
           this.$message.error(err.message)
           this.btnLoading = false
         })

      },
      handleClose(){
        this.dialogVisible = false
      },
      batchChange(e,index){
        if(e<=0){
          this.$nextTick(()=>{
            this.ruleForm.batch_list.splice(index,1)
          })
        }
      },
      // 选择时间
      selectChange(tab) {
        this.tableFrom.date = tab;
        this.tableFrom.page = 1;
        this.timeVal = [];
        this.getList(1);
      },
      // 具体日期
      onchangeTime(e) {
        this.timeVal = e;
        this.tableFrom.date = e ? this.timeVal.join("-") : "";
        this.tableFrom.page = 1;
        this.getList(1);
      },
      // 列表
      getList(num) {
        this.listLoading = true
        this.tableFrom.page = num ? num : this.tableFrom.page
        recoveryStockListApi(this.tableFrom).then(res => {
          this.tableData.data = res.data.list
          this.tableData.total = res.data.count
          this.listLoading = false
          this.getCardList()
        }).catch(res => {
          this.listLoading = false
          this.$message.error(res.message)
        })
      },
      pageChange(page) {
        this.tableFrom.page = page
        this.getList('')
      },
      detailChange(page){
        this.detailFrom.page = page
        this.getDetailListFn('')
      },
      detailSizeChange(val){
        this.detailFrom.limit = val
        this.getDetailListFn()
      },
      handleSizeChange(val) {
        this.tableFrom.limit = val
        this.getList('')
      },
      getCardList(){
        recoveryStockCardListApi(this.tableFrom)
          .then((res) => {
            this.cardLists = res.data;
          })
          .catch((res) => {
            this.$message.error(res.message);
          });
      },
      // 修改余额
      setRecoveryStock(row) {
        this.dialogVisible = true
        this.stockId = row.recovery_stock_id
        row.batchNum = 0
        this.stockItem = row
        this.ruleForm={
          type:1,
          stock:1,
          batch_list:[],
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  /deep/ .el-checkbox-group{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .box-container {
    overflow: hidden;
  }
  .font16{
    font-size: 14px;
  }
  .box-container .list {
    float: left;
    line-height: 40px;
  }
  .box-container .sp {
    width: 50%;
  }
  .box-container .sp3 {
    width: 33.3333%;
  }
  .box-container .sp100 {
    width: 100%;
  }
  .box-container .list .name {
    display: inline-block;
    width: 150px;
    text-align: right;
    color: #606266;
  }
  .box-container .list.image {
    margin-bottom: 40px;
  }
  .box-container .list.image img {
    position: relative;
    top: 40px;
  }
  /deep/.el-form-item__content .el-rate{
    position: relative;
    top: 8px;
  }
</style>
